import { defineMessage } from 'services/localization';

export const messages = {
    title: defineMessage('instruction_for_requesters'),
    subtitle: defineMessage('you_can_specify_a_messa_eate_a_new_templatename'),
    placeholder: defineMessage('enter_message_text'),
    instruction: defineMessage('leave_the_message_blank_questers_an_instruction'),
    defaultTemplateName: defineMessage('request'),
};
